import { FeatureCommitExecutionHandler, type FeatureCommitExecutionInput, type FeatureCommitExecutionResult } from './FeatureCommitExecutionHandler';

/**
 * 特征提交执行注册表。
 */
export class FeatureCommitExecutionRegistry {
    /** 已注册处理器。 */
    private readonly handlers: FeatureCommitExecutionHandler[] = [];

    /**
     * @param handlers 初始处理器集合。
     */
    public constructor(handlers: FeatureCommitExecutionHandler[] = []) {
        this.registerMany(handlers);
    }

    /**
     * 注册处理器。
     *
     * @param handler 处理器。
     * @returns 当前注册表。
     */
    public register(handler: FeatureCommitExecutionHandler): this {
        this.handlers.push(handler);
        return this;
    }

    /**
     * 批量注册处理器。
     *
     * @param handlers 处理器集合。
     * @returns 当前注册表。
     */
    public registerMany(handlers: FeatureCommitExecutionHandler[]): this {
        handlers.forEach((handler) => {
            this.register(handler);
        });
        return this;
    }

    /**
     * 执行特征提交。
     *
     * @param input 提交输入。
     * @returns 提交结果。
     * @throws 当输入的特征类型没有注册公开提交处理器时。
     */
    public async execute(input: FeatureCommitExecutionInput): Promise<FeatureCommitExecutionResult> {
        for (const handler of this.handlers) {
            if (!handler.supports(input)) {
                continue;
            }
            return handler.execute(input);
        }
        throw new Error(`当前未实现该特征的公开提交通道：${input.featureKind}`);
    }
}
